import MallGroupApi from '@/api/zfb/mall_group'


// 获取该PDD店铺对应的所有的店群
async function GetMallGroupList() {
  await MallGroupApi.GetMallGroupList()
}


// 创建店群
async function CreateGroup(createGroupName) {
  return await MallGroupApi.CreateGroup(createGroupName)
}

// 获取邀请码
async function GetInviteCode(GroupId) {
  return await MallGroupApi.GetInviteCode(GroupId)
}

// 加入店群
async function AddGroup(InviteCode) {
  return await MallGroupApi.AddGroup(InviteCode)
}

// 删除店群
async function DelGroup(groupId) {
  return await MallGroupApi.DelGroup(groupId)
}



export default {GetMallGroupList,CreateGroup,GetInviteCode,AddGroup,DelGroup}